/**
 * Helper function that returns true if both objects have the same keys and
 * values. Note that this comparision will not work with arrays and objects
 * which includes functions or undefined as some value .
 *
 * @param {Object} a
 * @param {Object} b
 */
export const objectsEqual = (a, b) => JSON.stringify(a) === JSON.stringify(b);
